<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <staging-control></staging-control>
      <staging-view></staging-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import StagingControl from "@/modules/batchAllocations/staging/stagingControl";
import StagingView from "@/modules/batchAllocations/staging/stagingView";
export default {
  components: {
    StagingView,
    StagingControl
  },
  methods: {}
};
</script>

<style>
</style>
